import { useState } from 'react'

import { Button, useToggle } from '@factorialco/deprecated-design-system'
import compact from 'lodash/compact'

import Popover from 'modules/core/components/Popover'
import PopoverContent from 'modules/core/components/Popover/Content'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import { DeleteGoalModal } from 'modules/goals/components/DeleteGoalModal'
import { EditGoalModal } from 'modules/goals/components/EditGoalModal'
import type GoalConfig from 'modules/goals/store/models/GoalConfig'

interface ActionsProps {
  goalConfig: GoalConfig
}

const Actions = ({ goalConfig }: ActionsProps) => {
  const { id } = useStrictParams<'id'>()
  const [open, toggle] = useToggle(false)
  const [showEditGoalModal, setShowEditGoalModal] = useState(false)
  const [showDeleteGoalModal, setShowDeleteGoalModal] = useState(false)

  const editItem = {
    title: i18n.t('surveys.goals.show.edit'),
    onClick: () => setShowEditGoalModal(true),
  }

  const deleteItem = {
    title: i18n.t('surveys.goals.show.delete'),
    onClick: () => setShowDeleteGoalModal(true),
    type: 'wrong',
  }

  const options = () => {
    const editOption = !goalConfig.isFinished ? editItem : null

    return compact([editOption, deleteItem])
  }

  if (!goalConfig.policy.can('editGoalConfig')) return null

  return (
    <>
      <Popover attachment="top center" toggle={toggle} open={open}>
        <Button
          onClick={toggle(true)}
          type="secondary"
          iconName="ellipsis"
          aria-label="Goal actions"
        />
        <PopoverContent onClose={toggle(false)} options={options()} />
      </Popover>

      {showEditGoalModal && <EditGoalModal id={id} onClose={() => setShowEditGoalModal(false)} />}
      {showDeleteGoalModal && (
        <DeleteGoalModal id={id} onClose={() => setShowDeleteGoalModal(false)} />
      )}
    </>
  )
}

export default Actions
